import React from 'react';

import * as styles from './seoSection.css';

export const SeoSection = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['container']}>{props.children}</div>;
};
